const STORAGE_KEY = 'grafx-vdp.tenantUrl';

/**
 * Resolve the Kadanza host origin from the iframe URL.
 *
 * With path-based routing, in-app navigation drops query params from the URL.
 * Persist the initial `tenantUrl` in sessionStorage so handshake + postMessage
 * keep working after the first load.
 */
export function resolveTenantUrlParam(): string | null {
  if (typeof window === 'undefined') return null;

  const fromUrl = new URLSearchParams(window.location.search).get('tenantUrl');
  if (fromUrl) {
    sessionStorage.setItem(STORAGE_KEY, fromUrl);
    return fromUrl;
  }

  return sessionStorage.getItem(STORAGE_KEY);
}
